module.exports = __webpack_public_path__ + "img/1106c_1.55a8a345.jpg";